import { ModalTypes } from '../../constants';
import { ModalParams } from '../../interface';

export const key = 'modals';

export type ModalsType = {
  modalType: ModalTypes | undefined;
  params: ModalParams | undefined;
  isOpen: boolean;
}

export type GlobalStore = {
  [key]: ModalsType;
}

export const initialState: ModalsType = {
  modalType: undefined,
  params: undefined,
  isOpen: false,
};
